import React from 'react';
import Layout from './Layout';
import { usePageMeta } from './shared';

const EMAIL = 'daniel@msmessagecenter.com';

export default function Contact() {
  usePageMeta({
    title: 'Contact | MS Message Center',
    description: 'Get in touch with Daniel Bradley, the creator of MS Message Center. Report bugs, suggest features, or connect on LinkedIn and X.',
    url: 'https://msmessagecenter.com/contact',
  });

  return (
    <Layout>
      <article className="max-w-screen-md mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-50 mb-2">Contact</h1>
        <p className="text-base text-gray-500 dark:text-gray-400 mb-8">
          Spotted a bug, have a feature idea, or just want to say hi? Get in touch.
        </p>

        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-6 mb-6">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Email</p>
          <a
            href={`mailto:${EMAIL}`}
            className="text-xl font-semibold text-blue-600 hover:text-blue-800 hover:underline break-all"
          >
            {EMAIL}
          </a>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-3 leading-relaxed">
            I read every message, but please bear with me on replies — this is a side project.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-6">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">Elsewhere</p>
          <ul className="space-y-2 text-base text-gray-700 dark:text-gray-300">
            <li>
              <a href="https://www.linkedin.com/in/danielbradley2/" target="_blank" rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
                LinkedIn
              </a>
              <span className="text-gray-400 dark:text-gray-500"> — for professional connections</span>
            </li>
            <li>
              <a href="https://x.com/DanielatOCN" target="_blank" rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
                X (@DanielatOCN)
              </a>
              <span className="text-gray-400 dark:text-gray-500"> — for quick questions and replies</span>
            </li>
            <li>
              <a href="https://ourcloudnetwork.com/" target="_blank" rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
                ourcloudnetwork.com
              </a>
              <span className="text-gray-400 dark:text-gray-500"> — my blog</span>
            </li>
          </ul>
        </div>
      </article>
    </Layout>
  );
}
